<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="4" lg="4" v-for="plant in plants" :key=plant.uuid>
                <PlantCard :plant="plant"></PlantCard>
            </v-col>
        </v-row>

        <v-btn fab dark large bottom right fixed color="green" :to="{name: 'PlantAdd'}" v-if="isAuthenticated">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
    import PlantCard from '../components/detail/plant/PlantCard'

    export default {
        name: 'Plants',
        components: {
            PlantCard
        },
        computed: {
            plants() {
                return this.$store.state.plant.plantList
            },
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            }
        },
        mounted() {
            this.$store.dispatch('getPlants');
        }
    };
</script>
